<div class="content-1920">
  <div class="content-padding margin-top-small">
    <h2>OEM Integrations</h2>
    <p class="muted">
      Connect Harvest Mate to your OEM Operations Center accounts to pull
      machine telemetry. Per-organisation data access for John Deere is managed
      below once connected.
    </p>

    @if (!managingProvider) {
    @for (u of unmappedCounts; track u.provider) {
    <app-unmapped-events-banner
      [count]="u.count"
      [provider]="u.provider"
      [providerLabel]="u.label"
      (mapClicked)="onMapClicked($event)"
    ></app-unmapped-events-banner>
    }

    @if (loading) {
    <div class="muted">Loading connections&hellip;</div>
    } @if (!loading && loadError) {
    <div class="alert alert-danger" role="alert">
      {{ loadErrorMessage }}
    </div>
    } @if (!loading && !loadError && rows.length === 0) {
    <div class="muted">No connections to display.</div>
    } @if (!loading && rows.length > 0) {
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Provider</th>
          <th scope="col">Status</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row) {
        <tr>
          <td>
            <strong>{{ row.label }}</strong>
            @if (row.provider === Provider.Deere && row.hasPendingGrants) {
            <div class="muted small">
              {{ row.status.orgs?.granted || 0 }} granted /
              {{ row.status.orgs?.pending || 0 }} pending /
              {{ row.status.orgs?.revoked || 0 }} revoked
            </div>
            }
          </td>
          <td>
            <span class="status-chip status-{{ row.uiStatus }}">
              {{ row.statusChip }}
            </span>
          </td>
          <td>
            <button
              type="button"
              [class.btn-oem-primary]="row.primaryAction === 'connect'"
              [class.btn-oem-primary-outline]="row.primaryAction !== 'connect'"
              (click)="onPrimary(row)"
            >
              {{ row.primaryLabel }}
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
    } } @else { @if (managingProvider && rowFor(managingProvider); as row) {
    <app-manage-view
      [provider]="managingProvider"
      [providerLabel]="row.label"
      [status]="row.status"
      [uiStatus]="row.uiStatus"
      [statusChip]="row.statusChip"
      (closed)="closeManage()"
    ></app-manage-view>
    } }
  </div>
</div>
